import { Injectable } from '@angular/core';
import { AppProxy, HttpMethod } from "./app-proxy";
import { ServerResponse } from 'http';
import { OrderAdding ,AdditonOrder, OrderAddingItemFood ,OrderHistory, MyOrder, HistoryDelivery, Order, UpdateOrderParams} from '../models/order';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ChangeFood, Restaurant, ToppingsItemFood } from '../models/restaurant';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DeletedInnerMenus, IngredientSave, SetsList, SetsSave } from '../models/setsMoal';

@Injectable()
export class OrdersService 
{
orderAddingList:OrderAdding[];
orderHistoryList:OrderHistory[];
historyDeliveryList:HistoryDelivery[];
order:MyOrder;
pos:number=-1;
position:number=-1;
orderDelivery:boolean=false;
deliveryOk:boolean=false;
deliveryCancel:boolean=false;
delivery:boolean=false;
restaurant:Restaurant;

    constructor(private http: HttpClient,private proxy: AppProxy,private router: Router ,private matDialog: MatDialog){}  

    getOrderDetails(nextPage:boolean)
    {
       
      let url= this.proxy.baseQAUrl+"OrderSets/getOrderDetails"
        return new Observable(observer => {
        this.proxy.execute<ServerResponse>(url,HttpMethod.Get)
        .subscribe(
            result => {
                let res: any = result;
                if (res.error==false)
                 {
                  let resList: MyOrder = res;
                  this.order=resList;   
                  observer.next(this.order)              
                }
              },
            error => console.log('oops', error));
        });
    }


    setOrderPayment(card_mask:string,card_validity:string,card_cvv:string,user_identity:string,invoice_name:string,TotalPrice:number, IsCancel3DS : boolean)
 {

  let url= this.proxy.baseQAUrl+"Order/setOrderPayment?card_mask="+card_mask+"&card_validity="+card_validity+"&card_cvv="+card_cvv+"&user_identity="+user_identity+"&invoice_name="+invoice_name
   +"&TotalPrice="+TotalPrice+"&IsCancel3DS="+IsCancel3DS;
   return new Observable(observer => {
   this.proxy.executePost<ServerResponse>(url,HttpMethod.Post)
   .subscribe(
    result => {
      let res: any = result;
      if (!res.error) {
        observer.next(res);
      } else {
        // Handle error response here
        this.proxy.showError(res.responseMessage, "");
        observer.next(res);
      }
    },
    error => {
      // Handle HTTP error here
      console.log('Oops', error);
      this.proxy.showError("Failed to process payment. Please try again later.", "");
     
    }
  );
     
   });
 }
//  addToBagOrder(MenuID:number,RestaurantID:number,Count:number)
//  {
//      let url= this.proxy.baseQAUrl+"Order/addToBagOrder?MenuID="+MenuID+"&RestaurantID="+RestaurantID+
//      "&Count="+Count;
//      return new Observable(observer => {
//      this.proxy.execute<ServerResponse>(url,HttpMethod.Post)
//      .subscribe(
//          result => {
//              let res: any = result;
//              if (res.error==false)
//               {
//                let resList: ServerResponse = res;
//                observer.next(resList);
//              }
//            },
//          error => console.log('oops', error));  
//      });
//  }

check3DS(OrderID:number)
{
  let url= this.proxy.baseQAUrl+"Order/check3DS2?OrderID="+OrderID;
  return new Observable(observer => {
  this.proxy.execute<ServerResponse>(url,HttpMethod.Post)
  .subscribe(
    result => {
        let res: any = result;
       
          let resList: ServerResponse = res;
          observer.next(resList);
       
      },
    error => console.log('oops', error));  
});
}

 

 addToBagOrder(MenuID:number,OrderID:number,DelNum:number)
    {
        let url= this.proxy.baseQAUrl+"OrderSets/setUpdateOrder?OrderID="+OrderID+"&MenuID="+MenuID+"&DelNum="+DelNum;
        return new Observable(observer => {
        this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
        .subscribe(
            result => {
                let res: any = result;
                if (res.error==false)
                 {
                  let resList: ServerResponse = res;
                  observer.next(resList);
                }
              },
            error => console.log('oops', error));  
        });
    }


    addToBagOrder_(MenuID:number,RestaurantID:number,Count:number , OrderListID?:number , ParentCountNumber?:number ,DishSetID?:number, IngredientID?:number)	

    {
      let urlOrder =  "OrderSets/addToBagOrder" ;

        let url= this.proxy.baseQAUrl+urlOrder + "?MenuID="+MenuID+"&RestaurantID="+RestaurantID+
        "&Count="+Count;
        if(OrderListID!=null && OrderListID>0)
        url+="&OrderListID="+OrderListID+ "&ParentCountNumber="+ParentCountNumber+ "&DishSetID="+DishSetID+"&IngredientID="+IngredientID;
        console.log(url)
        return new Observable(observer => {
        this.proxy.execute<ServerResponse>(url,HttpMethod.Post)
        .subscribe(
            result => {
                let res: any = result;
                if (res.error==false)
                 {
                  let resList: ServerResponse = res;
                  observer.next(resList);
                }
              },
            error => console.log('oops', error));  
        });
    }


    setUpdateOrder(params: UpdateOrderParams) {
      const urlParams = new URLSearchParams();
      
   
      const addParam = (key: string, value: any) => {
        if (value !== null && value !== undefined && value !== '') {
          urlParams.append(key, value.toString());
        }
      };
    
    
      Object.entries(params).forEach(([key, value]) => {
        addParam(key, value);
      });
     let uuu = 'OrderSets/setUpdateOrder';
      const baseUrl = this.proxy.baseQAUrl + uuu;
      const url = `${baseUrl}?${urlParams.toString()}`;
      
      return new Observable(observer => {
        this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
        .subscribe(
          
            result => {
                let res: any = result;
               
                 if(res.error==true && params.Status==2)
                  this.proxy.showError("שגיאה בסיום ההזמנה ",""); 
                 observer.next(res);
                if (res.error==false)
                 {
               
               
                 // observer.next(res);
                }
                
              },
            error => console.log('oops', error));   
        });
    }
    setUpdateOrderLast(OrderID:number,IsDelivery:number,IsPickUp:number,IsSitting:number,PaymentType:number,MenuID:number
      ,Count:number,Status:number,Note:string,IsAddress:number,Address:string,Latitude:string,Longitude:string,IsGiftCard:number,GiftNumber:number,SumGift:number,card_mask:string,card_validity:string){
        let url= this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&IsDelivery="+IsDelivery+
      "&IsPickUp="+IsPickUp+"&IsSitting="+IsSitting+"&PaymentType="+PaymentType+"&MenuID="+MenuID+"&Count="+Count+"&Status="+Status
      +"&Note="+Note+"&IsAddress="+IsAddress+"&Address="+Address+"&Latitude="+Latitude+"&Longitude="+Longitude+"&IsGiftCard="+IsGiftCard+"&GiftNumber="+GiftNumber+"&SumGift="+SumGift+"&card_mask="+card_mask+"&card_validity="+card_validity;
      return new Observable(observer => {
      this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
      .subscribe(
          result => {
              let res: any = result;
              if (res.error==false)
               {
                let resList: ServerResponse = res;
                observer.next(res);
              }
               else if(IsGiftCard==1)
                observer.next(res);
               else if(res.error==true && Status==2)
               this.proxy.showError("שגיאה בסיום ההזמנה ",""); 
               else  if(res.responseMessage=="the delivery out of bounds")
               observer.next(res);
            },
          error => console.log('oops', error));   
      });
    }

 

    // setUpdateOrder2(OrderID:number,UserName:string,UserPhone:string,
    //   userEmail:string,IsDelivery:number,IsPickUp:number,IsSitting:number,PaymentType:number,Status:number,Note:string,IsAddress:number){
    //   let url;
    //   if(Note!=null)
    //     url = this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&UserName="+UserName+"&UserPhone="+UserPhone+"&userEmail="+userEmail+"&IsDelivery="+IsDelivery+
    //   "&IsPickUp="+IsPickUp+"&IsSitting="+IsSitting+"&PaymentType="+PaymentType+"&Status="+Status
    //   +"&Note="+Note+"&IsAddress="+IsAddress;
    //   else
    //   url = this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&UserName="+UserName+"&UserPhone="+UserPhone+"&userEmail="+userEmail+"&IsDelivery="+IsDelivery+
    //   "&IsPickUp="+IsPickUp+"&IsSitting="+IsSitting+"&PaymentType="+PaymentType+"&Status="+Status
    //   "&IsAddress="+IsAddress;
    //   return new Observable(observer => {
    //   this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
    //   .subscribe(
    //       result => {
    //           let res: any = result;
    //           if (res.error==false)
    //            {
    //             let resList: ServerResponse = res;
    //             observer.next(res);             
    //           }       
    //         },
    //       error => console.log('oops', error));   
    //   });
    // }

    // setUpdateOrder4(OrderID:number,IsDelivery:number,IsPickUp:number,IsSitting:number,PaymentType:number,Status:number){
    //   let url;
    //  // url = this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&Status="+Status;
    //   url = this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&IsDelivery="+IsDelivery+
    //   "&IsPickUp="+IsPickUp+"&IsSitting="+IsSitting+"&PaymentType="+PaymentType+"&Status="+Status;
    //   return new Observable(observer => {
    //   this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
    //   .subscribe(
    //       result => {
    //           let res: any = result;
    //           if (res.error==false)
    //            {
    //             let resList: ServerResponse = res;
    //             observer.next(res);             
    //           }       
    //         },
    //       error => console.log('oops', error));   
    //   });
    // }

    // setUpdateOrder5(OrderID:number,IsDelivery:number,IsPickUp:number,IsSitting:number,PaymentType:number,Status:number,Address:string,Latitude:string,Longitude:string){
    //   let url;
    //   url = this.proxy.baseQAUrl+"Order/setUpdateOrder?OrderID="+OrderID+"&IsDelivery="+IsDelivery+
    //   "&IsPickUp="+IsPickUp+"&IsSitting="+IsSitting+"&PaymentType="+PaymentType+"&Status="+Status+"&Address="+Address+"&Latitude="+Latitude+"&Longitude="+Longitude;
    //   return new Observable(observer => {
    //   this.proxy.executePut<ServerResponse>(url,HttpMethod.Put)
    //   .subscribe(
    //       result => {
    //           let res: any = result;
    //           if (res.error==false)
    //            {
    //             let resList: ServerResponse = res;
    //             observer.next(res);             
    //           }       
    //         },
    //       error => console.log('oops', error));   
    //   });
    // }

    getOrderAdditon(MenuID,MenuNumber,pos,position)
    {
      let url= this.proxy.baseQAUrl+"Order/getOrderAdditon?MenuID="+MenuID+"&MenuNumber="+MenuNumber;
      return new Observable(observer => {
      this.proxy.execute<ServerResponse>(url,HttpMethod.Get)
      .subscribe(
          result => {
              let res: any = result;
              if (res.error==false)
               {
                  let resList: AdditonOrder = res;
                  this.orderAddingList=resList.list;
                  observer.next(resList);
                  let orderAddingItemFood=new OrderAddingItemFood();
                  orderAddingItemFood.ID=0;
                  orderAddingItemFood.Price=0;
                  orderAddingItemFood.Select=false;
                  if(this.restaurant!=null && this.restaurant.MenuList!=null && this.restaurant.MenuList[pos].ChangeFood!=null)
                 {
                  let changeFood=new ChangeFood();
                  if(this.restaurant.MenuList[pos].ChangeFood!=null)
                  {
                  if(this.restaurant.MenuList[pos].ChangeFood[position]!=null && this.restaurant.MenuList[pos].ChangeFood[position].Text!=null)
                  changeFood.Text=this.restaurant.MenuList[pos].ChangeFood[position].Text;
                  if(this.restaurant.MenuList[pos].ChangeFood[position]!=null && this.restaurant.MenuList[pos].ChangeFood[position].Name!=null)
                  changeFood.Name=this.restaurant.MenuList[pos].ChangeFood[position].Name;
                  let top:OrderAdding[]=[];
                  changeFood.toppings=top;
                  this.restaurant.MenuList[pos].ChangeFood[position]=changeFood;
                  this.restaurant.MenuList[pos].ChangeFood[position].toppings=this.orderAddingList;
                 }}
                 if(this.orderAddingList.length>0)
                 {
                   if(position>=0)
                   {
                    localStorage.position=position;
                    localStorage.pos=pos;
                 if(this.orderAddingList.length==1 && this.orderAddingList[0].listSelect.length>0 )
                 this.router.navigate(['../toppings2']); 
                 else
                 this.router.navigate(['../toppings2']);   
                   }
                 }
                    else if(this.order.list.length>0)
                     this.proxy.showError("אין רשימת תוספות ","");           
              }
            },
          error => console.log('oops', error));
      });  
    }
    // getOrderAdditon(MenuID,MenuNumber,pos,position)
    // {
    //   let url= this.proxy.baseQAUrl+"Order/getOrderAdditon?MenuID="+MenuID+"&MenuNumber="+MenuNumber;
    //   return new Observable(observer => {
    //   this.proxy.execute<ServerResponse>(url,HttpMethod.Get)
    //   .subscribe(
    //       result => {
    //           let res: any = result;
    //           if (res.error==false)
    //            {
    //               let resList: AdditonOrder = res;
    //               this.orderAddingList=resList.list;
    //               observer.next(resList);
    //               let orderAddingItemFood=new OrderAddingItemFood();
    //               orderAddingItemFood.ID=0;
    //               orderAddingItemFood.Price=0;
    //               orderAddingItemFood.Select=false;
    //               if(this.restaurant!=null && this.restaurant.MenuList!=null && this.restaurant.MenuList[pos].ChangeFood!=null)
    //              {
    //               let changeFood=new ChangeFood();
    //               if(this.restaurant.MenuList[pos].ChangeFood!=null)
    //               {
    //               if(this.restaurant.MenuList[pos].ChangeFood[position]!=null && this.restaurant.MenuList[pos].ChangeFood[position].Text!=null)
    //               changeFood.Text=this.restaurant.MenuList[pos].ChangeFood[position].Text;
    //               if(this.restaurant.MenuList[pos].ChangeFood[position]!=null && this.restaurant.MenuList[pos].ChangeFood[position].Name!=null)
    //               changeFood.Name=this.restaurant.MenuList[pos].ChangeFood[position].Name;
    //               let top:OrderAdding[]=[];
    //               changeFood.toppings=top;
    //               this.restaurant.MenuList[pos].ChangeFood[position]=changeFood;
    //               this.restaurant.MenuList[pos].ChangeFood[position].toppings=this.orderAddingList;
    //              }}
    //              if(this.orderAddingList.length>0)
    //              {
    //                if(position>=0)
    //                {
    //              if(this.orderAddingList.length==1 && this.orderAddingList[0].listSelect.length>0 )
    //              this.router.navigate(['../toppings',{pos, position}]); 
    //              else
    //              this.router.navigate(['../toppings',{pos, position}]);   
    //                }
    //              }
    //                 else this.proxy.showError("אין רשימת תוספות ","");           
    //           }
    //         },
    //       error => console.log('oops', error));
    //   });  
    // }



    sendConfirmationSms(OrderID:number , TotalPrice : number  = 0)
{
  let paymentType  = localStorage.paymentBy==1 ? 0 : 1
  let url= this.proxy.baseQAUrl+"Order/sendConfirmationSms?OrderID="+OrderID +"&TotalPayment=" + TotalPrice+ "&PaymentType="+ paymentType;;
  return new Observable(observer => {
  this.proxy.executePost<ServerResponse>(url,HttpMethod.Post)
    .subscribe(
      result => {
          let res: any = result;
          observer.next(res);
          if (res.error==false && res.responseMessage=="ok")
           {
          }
        },
      error => console.log('oops', error));
  });
}

setOrderSmsConfirmation(OrderID:number,SMSCode:string,innerWidth:any)
{
  let url= this.proxy.baseQAUrl+"Order/setOrderSmsConfirmation?OrderID="+OrderID+"&SMSCode="+SMSCode;
  return new Observable(observer => {
  this.proxy.executePost<ServerResponse>(url,HttpMethod.Post)
    .subscribe(
      result => {
          let res: any = result;
         // if(innerWidth<=480)
         // {
          // if (res.error==false && res.responseMessage=="ok")
            {
              observer.next(res);
            }
         // else
        //  {
       //   this.proxy.showError("קוד שגוי הזן שנית","");
        //   this.router.navigate(["/verificationCode"]);
        //   observer.next(res);
        //  }
        //  }
         // else
          //observer.next(res);
        },
      error => console.log('oops', error));
  });
}


   GetHistoryOrders(Search:string)
   {
    let url;
     if(Search!=null)
     url= this.proxy.baseQAUrl+"OrderSets/GetHistoryOrders?Search="+Search;
    else
    url= this.proxy.baseQAUrl+"OrderSets/GetHistoryOrders";
    return new Observable(observer => {
    this.proxy.execute<ServerResponse>(url,HttpMethod.Get)
    .subscribe(
        result => {
            let res: any = result;
            if (res.error==false)
             {
                let resList: OrderHistory[] = res.list;
                this.orderHistoryList=resList;
                if(this.orderHistoryList.length>0)
                observer.next(this.orderHistoryList)
                else this.proxy.showError("אין הזמנות בהיסטוריה","");
            }
          },
        error => console.log('oops', error)); 
    });
   }





setNewOrderByHistory(ID:number)
{
  let url= this.proxy.baseQAUrl+"OrderSets/setNewOrderByHistory?ID="+ID;
  return new Observable(observer => {
  this.proxy.executePost<ServerResponse>(url,HttpMethod.Post)
  .subscribe(
      result => {
          let res: any = result;
          if (res.error==false)
           {
            let resList: ServerResponse = res;
            observer.next(resList)
           // this.getOrderDetails(true);
          }
          else this.proxy.showError("שגיאה באחזור הזמנה מההיסטוריה","");
        },
      error => console.log('oops', error));  
  });
}



getSets(menuId: number, countNumber: number , ParentOrderListID?:number ,ParentCountNumber?:number , DishSetID?:number , IngredientID?:number ): Observable<SetsList> {
  console.log('countNumberInServiceGet:', countNumber);

let urlOrderSet =  "OrderSets/getSetsList" ;

  const params = new URLSearchParams({
    MenuID: menuId.toString(),
    CountNumber: countNumber.toString(),

  ParentOrderListID: ParentOrderListID ? ParentOrderListID.toString(): undefined,
  ParentCountNumber: ParentCountNumber ? ParentCountNumber.toString() : undefined,
  DishSetID: DishSetID ? DishSetID.toString() : undefined,
  IngredientID: IngredientID ? IngredientID.toString()  : undefined



  }).toString();

    let headers = this.proxy.creHeader();
let url = `${this.proxy.baseQAUrl}${urlOrderSet}?${params}`
  return this.http.get<SetsList>( url, {
    headers,
    
   
  }).pipe(
    map(response => {
      if (response.error == true) {
        throw new Error(response.responseMessage);
      }
      return response;
    }),
    catchError(error => {
      throw error;
    })
  );
}


private ingredientToDict(ingredient: IngredientSave): any {
  const sets = ingredient.Sets.map(set => this.setToDict(set)).filter(set => set !== null);
  return {
    ID: ingredient.ID,
    Sets: sets.length > 0 ? sets : []
  };
}

private setToDict(set: SetsSave): any {
  if (set.ID === 0 && (!set.Ingredients || set.Ingredients.length === 0)) {
    return { ID: set.ID, Ingredients: [] };
  }

  const ingredients = set.Ingredients.map(ingredient => this.ingredientToDict(ingredient))
                                  .filter(ingredient => ingredient !== null);
  return {
    ID: set.ID,
    Ingredients: ingredients
  };
}

  addOrderIngredient(
    orderListID: number,
    sets: SetsSave[],
    countNumber: number,
    dinerName: string,
    comments: string,
    dishesCount: number,
    deletedInnerMenus: DeletedInnerMenus[]
  ): Observable<boolean | null> {
    const parameters = {
      OrderListID: orderListID,
      Sets: sets.map(set => this.setToDict(set)),
      CountNumber: countNumber,
      DinerName: dinerName,
      Comments: comments,
      DishesCount: dishesCount,
      DeletedInnerMenus: deletedInnerMenus
    };

    console.log('Request Parameters:', JSON.stringify(parameters, null, 2));
    let headers = this.proxy.creHeader();
    let urlOrderSet =  "OrderSets/addOrderIngredient" ;
    let url = `${this.proxy.baseQAUrl}${urlOrderSet}`;
    return this.http.put<any>(
      url,
      parameters,
      { headers }
    ).pipe(
      map(response => {
        if (response) {
          return !response.error;
        }
        return null;
      }),
      catchError(error => {
        console.error('Request error:', error);
        return [null];
      })
    );
  }


  GetInnerDealDetails(
 ParentOrderListID: number,
 ParentCountNumber: number,
 DishSetID: number,
 IngredientID: number	

  ): Observable<Order> {
    const parameters = new URLSearchParams( {
      ParentOrderListID: ParentOrderListID.toString(),
      ParentCountNumber: ParentCountNumber.toString(),
      DishSetID: DishSetID.toString(),
      IngredientID: IngredientID.toString()
    }).toString();

    console.log('Request Parameters:', JSON.stringify(parameters, null, 2));
  
    let urlOrderSet =  "OrderSets/GetInnerDealDetails";
    let url = `${this.proxy.baseQAUrl}${urlOrderSet}?${parameters}`;
    return this.http.get<Order>(
      url,
      { headers: this.proxy.creHeader() }
    ).pipe(
      map(response => {
        if (response.error === false) {
          return response;
        }
        return null;
      }),
      catchError(error => {
        console.error('Request error:', error);
        return [null];
      })
    );
  }
//put /api/OrderSets/DeleteDealMenu

public DeleteDealMenu(
  OrderID: number,
  ParentOrderListID	: number,
  ParentCountNumber: number,
  DishSetID: number,
  IngredientID: number

  ): Observable<boolean | null> {
    const parameters =  new URLSearchParams({
      OrderID: OrderID.toString(),
      ParentOrderListID: ParentOrderListID.toString(),
      ParentCountNumber: ParentCountNumber.toString(),
      DishSetID: DishSetID.toString(),
      IngredientID: IngredientID.toString()
    }).toString();
   

    console.log('Request Parameters:', JSON.stringify(parameters, null, 2));
    let headers = this.proxy.creHeader();
    let urlOrderSet = "OrderSets/DeleteDealMenu";
    let url = `${this.proxy.baseQAUrl}${urlOrderSet}?${parameters}`;
    return this.http.put<any>(
      url,
      {},
      { headers }
    ).pipe(
      map(response => {
        if (response) {
          return !response.error;
        }
        return null;
      }),
      catchError(error => {
        console.error('Request error:', error);
        return [null];
      })
    );
  }

  //post /api/OrderSets/setDuplicateMenu
  setDuplicateMenu(
    ID: number,
    CountNumber: number
  ): Observable<boolean | null> {
    const parameters =  new URLSearchParams({
      ID: ID.toString(),
      CountNumber: CountNumber.toString()
    }).toString();

    let headers = this.proxy.creHeader();
     let urlOrderSet =  "OrderSets/setDuplicateMenu";
    let url = `${this.proxy.baseQAUrl}${urlOrderSet}?${parameters}`;
    return this.http.post<any>(
      url,
      {},
      { headers }
    ).pipe(
      map(response => {
        if (response) {
          return !response.error;
        }
        return null;
      }),
      catchError(error => {
        console.error('Request error:', error);
        return [null];
      })
    );
  }




}